"use client";

import { useState } from "react";
import { Play, X } from "lucide-react";
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const mediaItems = [{
  id: 1,
  title: "\n",
  category: "Intro",
  thumbnail: "https://cj-circle.com/wp-content/uploads/2026/05/copy_25563190-BDF8-4B08-BBA6-EB730FA627DF-1.mov?v=ftzbijs425g",
  duration: "8:15"
}, {
  id: 2,
  title: "Grip and Snap",
  category: "Step 1",
  thumbnail: "https://cj-circle.com/wp-content/uploads/2026/05/copy_6E1A26F5-CEFA-4CA9-B127-ADEC861976F6.mov?v=ecejpg2sgen",
  duration: "12:45"
}, {
  id: 3,
  title: "T-Position",
  category: "Step 2",
  thumbnail: "https://cj-circle.com/wp-content/uploads/2026/05/copy_BB753EEB-6D8A-4972-85C7-CFC85F000013.mov?v=gc5jqjspr9",
  duration: "10:20"
}, {
  id: 4,
  title: "K-Position",
  category: "Step 3\xA0",
  thumbnail: "https://cj-circle.com/wp-content/uploads/2026/05/copy_7DE881B9-C320-4270-91C0-AA3B87382DE4.mov?v=ujfc9sp98r",
  duration: "15:00"
}, {
  id: 5,
  title: "Flamingos",
  category: "Step 4\n",
  thumbnail: "https://cj-circle.com/wp-content/uploads/2026/05/copy_2FDD3C32-F119-40F3-909F-BEFB58B34D98.mov?v=rjk2z26pxfh",
  duration: "9:30"
}, {
  id: 6,
  title: "Walk-Throughs",
  category: "Step 5\xA0",
  thumbnail: "https://cj-circle.com/wp-content/uploads/2026/05/copy_FA8CEC24-B67D-41B8-93CE-932B1CB99E5A.mov?v=jy1ahcr2cl8",
  duration: "11:10"
}];
export default function VideoModules() {
  const [selectedVideo, setSelectedVideo] = useState<number | null>(null);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const selectedMedia = mediaItems.find(v => v.id === selectedVideo);
  return <section data-section-id="255205" id="video-modules" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        
        <div ref={ref} className={`mb-12 md:mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground mb-4">Free Warm Up Guide&nbsp;</h2>
          <p className="text-muted-foreground text-base md:text-xl max-w-2xl font-sans">A proper warm-up prepares your body to pitch at its best while helping prevent injury. Take your time, focus on quality movements, and get your body loose before every workout.</p>
        </div>

        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => <div key={item.id} data-index={i} className={`transition-all duration-700 delay-${i * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Card className="h-full overflow-hidden bg-card border-border hover:shadow-xl transition-shadow duration-300 rounded-lg">
                
                <div className="relative overflow-hidden bg-muted">
                  <AspectRatio ratio={16 / 9}>
                    <img src={item.thumbnail} alt={item.title} className="w-full h-full object-cover" loading="lazy" decoding="async" data-wvc-srcset={`${item.thumbnail}-wvc-srcset`} data-wvc-sizes={`${item.thumbnail}-wvc-sizes`} />
                  </AspectRatio>

                  
                  <div className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                    <Button onClick={() => setSelectedVideo(item.id)} size="icon" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 h-14 w-14 shadow-lg" aria-label={`Play video: ${item.title}`}>
                      <Play className="h-6 w-6 fill-current" />
                    </Button>
                  </div>

                  
                  
                </div>

                
                <CardContent className="pt-4 pb-4">
                  <Badge variant="outline" className="mb-3 border-primary text-primary font-sans">
                    {item.category}
                  </Badge>
                  <h3 className="font-default font-bold text-foreground text-lg leading-snug">
                    {item.title}
                  </h3>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <Dialog open={selectedVideo !== null} onOpenChange={open => !open && setSelectedVideo(null)}>
          <DialogContent className="max-w-4xl p-0 overflow-hidden bg-black border-none rounded-lg">
            <div className="relative w-full h-full flex flex-col">
              <div className="p-4 flex items-center justify-between bg-background/80 backdrop-blur-sm">
                <h3 className="font-default font-bold text-foreground text-xl">
                  {selectedMedia?.title}
                </h3>
                <DialogClose asChild>
                  <Button variant="ghost" size="icon" className="rounded-lg hover:bg-accent">
                    <X className="h-6 w-6" />
                  </Button>
                </DialogClose>
              </div>
              <div className="bg-black flex items-center justify-center">
                {selectedMedia && <video src={selectedMedia.thumbnail} controls autoPlay className="w-full max-h-[80vh] rounded-lg" />}
              </div>
            </div>
          </DialogContent>
        </Dialog>

        
        
      </div>
    </section>;
}